module.exports = __webpack_public_path__ + "img/comment-exclamation.ecc4b841.svg";